query GetMatchCampaignCategory($id: ID!) {
  matchCampaignCategory(id: $id) {
    id
    name
    tagText
    icon
    colour
    showAgainstTransactions
    categoryType
  }
}
